import React, { useEffect, useState } from 'react';
import './index.scss';
import { Typography, Tabs, notification, Card, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import API_SERVICE from 'shared/services/api-service';
import ProductCardGrid from '../../components/ProductCardGrid/ProductCardGrid';
import Paragraph from 'antd/es/typography/Paragraph';
import { useHistory } from 'react-router-dom';

const { TabPane } = Tabs;

const { Title } = Typography;
export default function PopularCoursesSection() {
    const { t } = useTranslation();
    const history = useHistory();
    const [categories, setCategories] = useState([] as any[]);
    useEffect(() => {
        API_SERVICE.fetchCategories({ per_page: 4 }).then(({ data: { data: { items } } }) => {
            setCategories(items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        });
    }, []);
    return (
        <div className={'featured-courses-section mb-0'}>
            <div className="container-fluid home-top-course pt-4 pb-4">
                <div className="plr-4rem">
                    <Title level={3}>{t('home.popularCourses')}</Title>
                    <div className=''>
                        <ProductCardGrid numberOfCourses={4} isPopular={true}/>
                        <div className='text-center'>
                            <Button className='btn btn-blue' onClick={() => {
                                history.push(`/courses?isPopular=true`);
                            }
                            }>{t('genDict.explore')}</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
